export const columns = [
    {
        Header: '#',
        accessor: 'id',
    },
    {
        Header: 'Domain',
        accessor: 'domain',
    },
    {
        Header: 'Company(Name)',
        accessor: 'name',
    },
    {
        Header: 'Email',
        accessor: 'email',
    },

    {
        Header: 'First name',
        accessor: 'first_name',
    },
    {
        Header: 'Last name',
        accessor: 'last_name',
    },
    {
        Header: 'Trial',
        accessor: 'trial_expires',
    },
    {
        Header: 'Active',
        accessor: 'is_active',
    },
    {
        Header: 'Confirmed',
        accessor: 'confirmed',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
        disableGlobalFilter: true,
        disableSortBy: true
    },
];